import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadge = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted'
    },
    {
      icon: 'Lock',
      text: '2FA Protected'
    },
    {
      icon: 'Eye',
      text: 'Activity Monitored'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-soft">
      <div className="flex items-center space-x-2 mb-3">
        <Icon name="ShieldCheck" size={20} color="var(--color-accent)" />
        <span className="text-sm font-medium text-foreground">Security Features</span>
      </div>
      <div className="space-y-2">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2">
            <Icon name={feature?.icon} size={14} color="var(--color-muted-foreground)" />
            <span className="text-xs text-muted-foreground">{feature?.text}</span>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-border">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-accent rounded-full live-indicator"></div>
          <span className="text-xs text-accent font-medium">System Online</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadge;